import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Autocomplete } from "@material-ui/lab";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getVesselManagerAPI } from "../api";
import VesselViewModel from "./VesselViewModel";

import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { initialContractFields } from ".";
import CustomTabs from "../../../../common/Tabs";
import CustomAddModal from "../../../../components/Common/CustomAddModal";
import CustomShowModal from "../../../../components/Common/CustomShowModal";
import ShareWithOrg from "../../../../components/Common/ShareWithOrg";
import { termsCoEfficientTable } from "../../../../constants";
import {
  getCurrentUserOrganizationId,
  toastError,
  toastSuccess,
} from "../../../../utils";
import CreateCargoContractForm from "../../Orders/createCargoContractModel";
import ActionButtonsCargoCargo from "../CargoCargoMatrixMain/ActionButtonsCargoCargo";
import CargoCargoPortOperations from "../CargoCargoMatrixMain/CargoCargoPortOperations";
import CargoCargoResult from "../CargoCargoMatrixMain/CargoCargoResult";
import CargoDetails from "../CargoCargoMatrixMain/CargoDetails";
import Expense from "../CargoCargoMatrixMain/Expense";
import NetProfitResult from "../CargoCargoMatrixMain/NetProfitResult";
import Revenue from "../CargoCargoMatrixMain/Revenue";
import {
  allVesselsByCharWithoutReducer,
  createEstimateContract,
  getEstimateContractById,
  updateEstimateCargo,
} from "../actions";

const mapVesselConsumptions = (vesselData) => {
  if (!vesselData) return {};

  if (!vesselData.Ballast_Sea_Consumptions && !vesselData.Laden_Sea_Consumptions) {
    return vesselData;
  }

  const ballastConsumptions = vesselData?.Ballast_Sea_Consumptions || {};
  const ladenConsumptions = vesselData?.Laden_Sea_Consumptions || {};

  return {
    vesselBalSpd1: ballastConsumptions.col_1?.Speed || 0,
    vesselBalConsmHS1: ballastConsumptions.col_1?.HS || 0,
    vesselBalConsmLS1: ballastConsumptions.col_1?.LS || 0,
    vesselBalConsmMGO1: ballastConsumptions.col_1?.MGO || 0,
    vesselBalSpd2: ballastConsumptions.col_2?.Speed || 0,
    vesselBalConsmHS2: ballastConsumptions.col_2?.HS || 0,
    vesselBalConsmLS2: ballastConsumptions.col_2?.LS || 0,
    vesselBalConsmMGO2: ballastConsumptions.col_2?.MGO || 0,
    vesselBalSpd3: ballastConsumptions.col_3?.Speed || 0,
    vesselBalConsmHS3: ballastConsumptions.col_3?.HS || 0,
    vesselBalConsmLS3: ballastConsumptions.col_3?.LS || 0,
    vesselBalConsmMGO3: ballastConsumptions.col_3?.MGO || 0,
    vesselBalSpd4: ballastConsumptions.col_4?.Speed || 0,
    vesselBalConsmHS4: ballastConsumptions.col_4?.HS || 0,
    vesselBalConsmLS4: ballastConsumptions.col_4?.LS || 0,
    vesselBalConsmMGO4: ballastConsumptions.col_4?.MGO || 0,

    vesselLdnSpd1: ladenConsumptions.col_1?.Speed || 0,
    vesselLdnConsmHS1: ladenConsumptions.col_1?.HS || 0,
    vesselLdnConsmLS1: ladenConsumptions.col_1?.LS || 0,
    vesselLdnConsmMGO1: ladenConsumptions.col_1?.MGO || 0,
    vesselLdnSpd2: ladenConsumptions.col_2?.Speed || 0,
    vesselLdnConsmHS2: ladenConsumptions.col_2?.HS || 0,
    vesselLdnConsmLS2: ladenConsumptions.col_2?.LS || 0,
    vesselLdnConsmMGO2: ladenConsumptions.col_2?.MGO || 0,
    vesselLdnSpd3: ladenConsumptions.col_3?.Speed || 0,
    vesselLdnConsmHS3: ladenConsumptions.col_3?.HS || 0,
    vesselLdnConsmLS3: ladenConsumptions.col_3?.LS || 0,
    vesselLdnConsmMGO3: ladenConsumptions.col_3?.MGO || 0,
    vesselLdnSpd4: ladenConsumptions.col_4?.Speed || 0,
    vesselLdnConsmHS4: ladenConsumptions.col_4?.HS || 0,
    vesselLdnConsmLS4: ladenConsumptions.col_4?.LS || 0,
    vesselLdnConsmMGO4: ladenConsumptions.col_4?.MGO || 0,
  };
};

export default function CargoCargoContract(props) {
  const { setLoader = () => { }, setIsFullScreen = () => { }, contractId, tabs, active, handleMainTabChange } = props;
  const { id = contractId } = useParams();
  const [calculatorData, setCalculatorData] = useState(null);

  const organizationId = getCurrentUserOrganizationId();
  const [openCargoDetails, setOpenCargoDetails] = useState(false);
  const [isCopyConfirm, setCopyConfirm] = useState(false);
  const [shareLabel, setShareLabel] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [rawEstimateContract, setRawEstimateContract] = useState();
  const [editCargoContractModelOpen, setEditCargoContractModelOpen] =
    useState(false);
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [cargoTextContract, setCargoTextContract] = useState(null);
  const [prevAttachments, setPrevAttachments] = useState({
    attachments: [],
    textContract: "",
  });

  const [vesselOptions, setVesselOptions] = useState([]);
  const [isVesselLoading, setIsVesselLoading] = useState(false);
  const vesselManagerDataRef = useRef(null);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [showVesselModal, setShowVesselModal] = useState(false);
  const [previewVessel, setPreviewVessel] = useState(null);
  const vesselModelRef = useRef(null);

  useEffect(() => {
    getVesselManagerAPI()
      .then((res) => {
        vesselManagerDataRef.current = res?.data?.allVesselManager || {};
      })
      .catch(() => { });
  }, []);

  const delayVesselSearch = React.useCallback(
    debounce((search) => onSearchVesselList(search), 500),
    []
  );

  const onSearchVesselList = (value) => {
    if (value) {
      setIsVesselLoading(true);
      allVesselsByCharWithoutReducer(value)
        .then((res) => {
          setIsVesselLoading(false);
          setVesselOptions(
            (Array.isArray(res.data.list) &&
              res.data.list.map((item) => {
                let parsed = item;
                try {
                  parsed = item.vessel ? JSON.parse(item.vessel) : item;
                } catch (e) { }
                return {
                  ...item,
                  vesselData: parsed,
                  vesselLabel: `${item.vesselName} (${item.vesselDwt || parsed.vesselDwt || parsed.DWT || parsed.dwt || 0})`,
                };
              })) || [],
          );
        })
        .catch(() => {
          setIsVesselLoading(false);
        });
    } else {
      setVesselOptions([]);
    }
  };

  const savedVesselValue = React.useMemo(() => {
    if (calculatorData?.performingVessel) {
      let savedVesselObj = {};
      try {
        if (typeof calculatorData.performingVessel === "string" && calculatorData.performingVessel.trim().startsWith("{")) {
          savedVesselObj = JSON.parse(calculatorData.performingVessel);
        } else if (typeof calculatorData.performingVessel === "object") {
          savedVesselObj = calculatorData.performingVessel;
        } else {
          savedVesselObj = { vesselName: calculatorData.performingVessel };
        }
      } catch (e) {
        savedVesselObj = { vesselName: calculatorData.performingVessel };
      }
      const label = savedVesselObj.vesselName
        ? `${savedVesselObj.vesselName}${savedVesselObj.vesselDwt ? ` (${savedVesselObj.vesselDwt})` : ""}`
        : String(calculatorData.performingVessel);

      return {
        ...savedVesselObj,
        vesselLabel: label,
        vessel: typeof calculatorData.performingVessel === "string" ? calculatorData.performingVessel : JSON.stringify(calculatorData.performingVessel),
      };
    }
    return null;
  }, [calculatorData?.performingVessel]);

  const parseDate = (dateStr) => {
    const [date, time] = dateStr?.split(" ");
    const [month, day, year] = date?.split("/");
    return new Date(
      `20${year}-${month?.padStart(2, "0")}-${day?.padStart(2, "0")}T${time}:00`
    );
  };

  const calculateDifference = (arrivalTime, departureTime) => {
    const arrivalDate = parseDate(moment(arrivalTime).format("M/D/YY HH:mm"));
    const departureDate = parseDate(
      moment(departureTime).format("M/D/YY HH:mm")
    );
    const timeDiff = departureDate - arrivalDate;
    const diffInDays = timeDiff / (1000 * 60 * 60 * 24);
    return diffInDays.toFixed(9);
  };

  const structureChange = (currentdata) => {
    currentdata?.vesselVoyageData?.map((item) => {
      if (item?.arrivalTime && item?.departureTime) {
        item.portStay = calculateDifference(
          item?.arrivalTime,
          item?.departureTime
        );
      }
    });
    return currentdata;
  };
  useEffect(() => {
    setIsFullScreen(true);
    if (id) {
      getInitialData(id);
    }
    return () => {
      setIsFullScreen(false);
    };
  }, []);
  const getInitialData = (id) => {
    setLoader(true, "Fetching cargo contract data...");
    getEstimateContractById({ id })
      .then((res) => {
        setLoader(false);
        setIsPrivate(res?.data?.access === "public" ? false : true);
        setRawEstimateContract(res?.data);
        const structureData = structureChange(
          res?.data?.cargoContractDetails?.cargoDetails
        );
        const vesselVoyageData = [];

        // Fixed logic: Check if the property exists first, then check its length
        if (
          !structureData?.vesselVoyageData ||
          structureData.vesselVoyageData.length === 0
        ) {
          structureData?.cargoList?.forEach((element) => {
            if (
              element?.operation?.toLowerCase() === "loading" ||
              element?.operation?.toLowerCase() === "discharging"
            ) {
              vesselVoyageData.push({
                _id: uuidv4(),
                operation: element?.operation,
                port: element?.port,
                lat: element?.lat,
                lng: element?.lng,
                cargoQty: element?.cargoQty,
                cargo: element?.cargo,
                min: element?.min,
                max: element?.max,
                laycanStartDate: null,
                laycanEndDate: null,
                stowFactor: element?.stowFactor,
                actualCargoQty: 0,
                tolerance: element?.tolerance || 0,
                arrivalTime: null,
                departureTime: null,
                portStay: 0,
              });
            }
          });
        }
        const updatedData = {
          ...structureData,
          vendorCargo: !structureData?.vendorCargo
            ? structureData
            : structureData?.vendorCargo,
          customerCargo: !structureData?.customerCargo
            ? structureData
            : structureData?.customerCargo,
          vesselVoyageData: structureData?.vesselVoyageData?.length
            ? structureData.vesselVoyageData
            : vesselVoyageData,

          performingVessel:
            structureData?.performingVessel ||
            (typeof structureData?.vesselData?.vessel === "string"
              ? JSON.parse(structureData?.vesselData?.vessel || "{}").vesselName
              : structureData?.vesselData?.vesselName) || "",
        };

        setCalculatorData(updatedData);
        calculate(updatedData);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const calculate = (calculatordata) => {
    const currentdata = calculatordata;
    currentdata.calculateRates = [];

    const revenueKeys = [
      "laytimeAllowed",
      "demurrageAmt",
      "despatchAmt",
      "grossFreightAmt",
      "adcomAmt",
      "othersAmt",
      "brokerageAmt",
      "netFreightRevenue",
      "laytimeRevenue",
      "netRevenue",
    ];
    function calculateDemurrage(
      laytimeIncurred,
      laytimeAllowed,
      demurrageRate
    ) {
      const difference = laytimeIncurred - laytimeAllowed;

      if (difference >= 0) {
        return difference * demurrageRate;
      }

      return 0;
    }
    function calculateDespatch(laytimeIncurred, laytimeAllowed, despatchRate) {
      if (laytimeIncurred - laytimeAllowed < 0) {
        return (laytimeAllowed - laytimeIncurred) * despatchRate;
      }
      return 0;
    }

    function calculateGrossFreightAmount(freightRate, actualCargoQty) {
      return freightRate * actualCargoQty;
    }
    function calculateAdcomAmount(grossFreightAmount, adcomRate) {
      return (grossFreightAmount * adcomRate) / 100;
    }
    function calculateOthersAmount(grossFreightAmount, otherTaxRate) {
      return (grossFreightAmount * otherTaxRate) / 100;
    }

    function calculateBrokerageAmount(grossFreightAmount, brokerageRate) {
      return (grossFreightAmount * brokerageRate) / 100;
    }

    function calculateNetFreightRevenue(
      grossFreightAmount,
      adcomAmount,
      othersAmount,
      brokerageAmount
    ) {
      return grossFreightAmount - adcomAmount - othersAmount - brokerageAmount;
    }
    function calculateNetFreightExpense(
      grossFreightAmount,
      adcomAmount,
      othersAmount,
      brokerageAmount
    ) {
      return grossFreightAmount - adcomAmount + othersAmount + brokerageAmount;
    }

    function calculateLaytimeRevenue(demurrageAmount, despatchAmount) {
      return demurrageAmount - despatchAmount;
    }

    function calculateNetRevenue(
      freightRevenue,
      laytimeRevenue,
      additionalRevenue,
      additionalExpense
    ) {
      return (
        freightRevenue + laytimeRevenue + additionalRevenue - additionalExpense
      );
    }

    function calculateProfitPerUnit(netProfit, actualCargoQty) {
      if (
        actualCargoQty === 0 ||
        actualCargoQty === undefined ||
        actualCargoQty === null
      ) {
        return 0;
      }
      return netProfit / actualCargoQty;
    }

    for (let i = 0; i < revenueKeys?.length; i++) {
      let calculateRates = {};
      if (
        currentdata?.vesselVoyageData?.[i]?.actualCargoQty &&
        currentdata?.customerCargo?.cargoList?.[i]?.rate
      ) {
        calculateRates = {
          ...calculateRates,
          LaytimeAllowedRevenue:
            Number(currentdata?.vesselVoyageData[i]?.actualCargoQty || 0) /
            Number(currentdata?.customerCargo?.cargoList[i]?.rate),
        };
      }
      if (
        currentdata?.vesselVoyageData[i]?.actualCargoQty &&
        currentdata?.vendorCargo?.cargoList[i]?.rate
      ) {
        calculateRates = {
          ...calculateRates,
          LaytimeAllowedExpense:
            Number(currentdata?.vesselVoyageData[i]?.actualCargoQty || 0) /
            Number(currentdata?.vendorCargo?.cargoList[i]?.rate),
        };
      }
      if (
        calculateRates?.LaytimeAllowedRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.laytimeIncurred ||
        currentdata?.customerCargo?.cargoList[i]?.demurrageRate
      ) {
        calculateRates = {
          ...calculateRates,
          DemurrageAmtRevenue: calculateDemurrage(
            Number(
              currentdata?.customerCargo?.cargoList[i]?.laytimeIncurred || 0
            ),
            Number(calculateRates?.LaytimeAllowedRevenue || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.demurrageRate || 0)
          ),
        };
      }
      if (
        calculateRates?.LaytimeAllowedExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.laytimeIncurred ||
        currentdata?.vendorCargo?.cargoList[i]?.demurrageRate
      ) {
        calculateRates = {
          ...calculateRates,
          DemurrageAmtExpense: calculateDemurrage(
            Number(
              currentdata?.vendorCargo?.cargoList[i]?.laytimeIncurred || 0
            ),
            Number(calculateRates?.LaytimeAllowedExpense || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.demurrageRate || 0)
          ),
        };
      }

      if (
        calculateRates?.LaytimeAllowedRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.laytimeIncurred ||
        currentdata?.customerCargo?.cargoList[i]?.despatchRate
      ) {
        calculateRates = {
          ...calculateRates,
          DespatchAmtRevenue: calculateDespatch(
            Number(
              currentdata?.customerCargo?.cargoList[i]?.laytimeIncurred || 0
            ),
            Number(calculateRates?.LaytimeAllowedRevenue || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.despatchRate || 0)
          ),
        };
      }
      if (
        calculateRates?.LaytimeAllowedExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.laytimeIncurred ||
        currentdata?.vendorCargo?.cargoList[i]?.despatchRate
      ) {
        calculateRates = {
          ...calculateRates,
          DespatchAmtExpense: calculateDespatch(
            Number(
              currentdata?.vendorCargo?.cargoList[i]?.laytimeIncurred || 0
            ),
            Number(calculateRates?.LaytimeAllowedExpense || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.despatchRate || 0)
          ),
        };
      }
      if (
        currentdata?.vesselVoyageData?.[i]?.actualCargoQty ||
        currentdata?.customerCargo?.cargoList[i]?.freight
      ) {
        calculateRates = {
          ...calculateRates,
          grossFreightAmountRevenue: calculateGrossFreightAmount(
            Number(currentdata?.vesselVoyageData?.[i]?.actualCargoQty || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.freight || 0)
          ),
        };
      }

      if (
        currentdata?.vesselVoyageData?.[i]?.actualCargoQty ||
        currentdata?.customerCargo?.cargoList[i]?.freight
      ) {
        calculateRates = {
          ...calculateRates,
          grossFreightAmountExpense: calculateGrossFreightAmount(
            Number(currentdata?.vesselVoyageData?.[i]?.actualCargoQty || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.freight || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.adcom
      ) {
        calculateRates = {
          ...calculateRates,
          adcomAmountRevenue: calculateAdcomAmount(
            Number(calculateRates?.grossFreightAmountRevenue || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.adcom || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.adcom
      ) {
        calculateRates = {
          ...calculateRates,
          adcomAmountExpense: calculateAdcomAmount(
            Number(calculateRates?.grossFreightAmountExpense || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.adcom || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.other
      ) {
        calculateRates = {
          ...calculateRates,
          othersAmountRevenue: calculateOthersAmount(
            Number(calculateRates?.grossFreightAmountRevenue || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.other || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.other
      ) {
        calculateRates = {
          ...calculateRates,
          othersAmountExpense: calculateOthersAmount(
            Number(calculateRates?.grossFreightAmountExpense || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.other || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.brokerage
      ) {
        calculateRates = {
          ...calculateRates,
          brokerageAmountRevenue: calculateBrokerageAmount(
            Number(calculateRates?.grossFreightAmountRevenue || 0),
            Number(currentdata?.customerCargo?.cargoList[i]?.brokerage || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.brokerage
      ) {
        calculateRates = {
          ...calculateRates,
          brokerageAmountExpense: calculateBrokerageAmount(
            Number(calculateRates?.grossFreightAmountExpense || 0),
            Number(currentdata?.vendorCargo?.cargoList[i]?.brokerage || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountRevenue ||
        calculateRates?.adcomAmountRevenue ||
        calculateRates?.othersAmountRevenue ||
        calculateRates?.brokerageAmountRevenue
      ) {
        calculateRates = {
          ...calculateRates,
          netFreightRevenue: calculateNetFreightRevenue(
            Number(calculateRates?.grossFreightAmountRevenue || 0),
            Number(calculateRates?.adcomAmountRevenue || 0),
            Number(calculateRates?.othersAmountRevenue || 0),
            Number(calculateRates?.brokerageAmountRevenue || 0)
          ),
        };
      }

      if (
        calculateRates?.grossFreightAmountExpense ||
        calculateRates?.adcomAmountExpense ||
        calculateRates?.othersAmountExpense ||
        calculateRates?.brokerageAmountExpense
      ) {
        calculateRates = {
          ...calculateRates,
          netFreightExpense: calculateNetFreightExpense(
            Number(calculateRates?.grossFreightAmountExpense || 0),
            Number(calculateRates?.adcomAmountExpense || 0),
            Number(calculateRates?.othersAmountExpense || 0),
            Number(calculateRates?.brokerageAmountExpense || 0)
          ),
        };
      }

      if (
        calculateRates?.netFreightRevenue ||
        calculateRates?.netFreightExpense
      ) {
        calculateRates = {
          ...calculateRates,
          totalNetFreight:
            Number(calculateRates?.netFreightRevenue || 0) -
            Number(calculateRates?.netFreightExpense || 0),
        };
      }

      if (
        calculateRates?.DemurrageAmtRevenue ||
        calculateRates?.DespatchAmtRevenue
      ) {
        calculateRates = {
          ...calculateRates,
          laytimeRevenueRevenue: calculateLaytimeRevenue(
            Number(calculateRates?.DemurrageAmtRevenue || 0),
            Number(calculateRates?.DespatchAmtRevenue || 0)
          ),
        };
      }

      if (
        calculateRates?.DemurrageAmtExpense ||
        calculateRates?.DespatchAmtExpense
      ) {
        calculateRates = {
          ...calculateRates,
          laytimeRevenueExpense: calculateLaytimeRevenue(
            Number(calculateRates?.DemurrageAmtExpense || 0),
            Number(calculateRates?.DespatchAmtExpense || 0)
          ),
        };
      }

      if (
        calculateRates?.laytimeRevenueRevenue ||
        calculateRates?.laytimeRevenueExpense
      ) {
        calculateRates = {
          ...calculateRates,
          totalLaytimeProfit:
            Number(calculateRates?.laytimeRevenueRevenue || 0) -
            Number(calculateRates?.laytimeRevenueExpense || 0),
        };
      }

      if (
        calculateRates?.netFreightRevenue ||
        calculateRates?.laytimeRevenueRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.additionalRevenue ||
        currentdata?.customerCargo?.cargoList[i]?.additionalExpense
      ) {
        calculateRates = {
          ...calculateRates,
          netRevenue: calculateNetRevenue(
            Number(calculateRates?.netFreightRevenue || 0),
            Number(calculateRates?.laytimeRevenueRevenue || 0),
            Number(
              currentdata?.customerCargo?.cargoList[i]?.additionalRevenue || 0
            ),
            Number(
              currentdata?.customerCargo?.cargoList[i]?.additionalExpense || 0
            )
          ),
        };
      }

      if (
        calculateRates?.netFreightExpense ||
        calculateRates?.laytimeRevenueExpense ||
        currentdata?.vendorCargo?.cargoList[i]?.additionalRevenue ||
        currentdata?.vendorCargo?.cargoList[i]?.additionalExpense
      ) {
        calculateRates = {
          ...calculateRates,
          netExpense: calculateNetRevenue(
            Number(calculateRates?.netFreightExpense || 0),
            Number(calculateRates?.laytimeRevenueExpense || 0),
            Number(
              currentdata?.vendorCargo?.cargoList[i]?.additionalRevenue || 0
            ),
            Number(
              currentdata?.vendorCargo?.cargoList[i]?.additionalExpense || 0
            )
          ),
        };
      }

      if (
        calculateRates?.totalNetFreight ||
        calculateRates?.totalLaytimeProfit
      ) {
        calculateRates = {
          ...calculateRates,
          netProfit:
            Number(calculateRates?.totalNetFreight) +
            Number(calculateRates?.totalLaytimeProfit),
        };
      }

      if (calculateRates?.netProfit) {
        calculateRates = {
          ...calculateRates,
          profitPerUnit: calculateProfitPerUnit(
            calculateRates?.netProfit,
            currentdata?.vesselVoyageData?.[i]?.actualCargoQty
          ),
        };
      }

      if (Object.keys(calculateRates).length > 0) {
        currentdata.calculateRates.push(calculateRates);
      }
    }

    const totalCalculatedRates = {
      totalDemurrageAmtExpense: 0,
      totalDemurrageAmtRevenue: 0,
      totalDespatchAmtExpense: 0,
      totalDespatchAmtRevenue: 0,
      totalGrossFreightAmountExpense: 0,
      totalGrossFreightAmountRevenue: 0,
      totalAdcomAmountExpense: 0,
      totalAdcomAmountRevenue: 0,
      totalOthersAmountExpense: 0,
      totalOthersAmountRevenue: 0,
      totalBrokerageAmountExpense: 0,
      totalBrokerageAmountRevenue: 0,
      totalNetFreightRevenue: 0,
      totalNetFreightExpense: 0,
      totalLaytimeRevenueRevenue: 0,
      totalLaytimeRevenueExpense: 0,
      totalNetRevenue: 0,
      totalNetExpense: 0,
      totalNetFreight: 0,
      totalLaytimeProfit: 0,
      netProfit: 0,
    };
    currentdata.calculateRates.forEach((rate) => {
      totalCalculatedRates.totalDemurrageAmtExpense +=
        rate.DemurrageAmtExpense || 0;
      totalCalculatedRates.totalDemurrageAmtRevenue +=
        rate.DemurrageAmtRevenue || 0;
      totalCalculatedRates.totalDespatchAmtExpense +=
        rate.DespatchAmtExpense || 0;
      totalCalculatedRates.totalDespatchAmtRevenue +=
        rate.DespatchAmtRevenue || 0;
      totalCalculatedRates.totalGrossFreightAmountExpense +=
        rate.grossFreightAmountExpense || 0;
      totalCalculatedRates.totalGrossFreightAmountRevenue +=
        rate.grossFreightAmountRevenue || 0;
      totalCalculatedRates.totalAdcomAmountExpense +=
        rate.adcomAmountExpense || 0;
      totalCalculatedRates.totalAdcomAmountRevenue +=
        rate.adcomAmountRevenue || 0;
      totalCalculatedRates.totalOthersAmountExpense +=
        rate.othersAmountExpense || 0;
      totalCalculatedRates.totalOthersAmountRevenue +=
        rate.othersAmountRevenue || 0;
      totalCalculatedRates.totalBrokerageAmountExpense +=
        rate.brokerageAmountExpense || 0;
      totalCalculatedRates.totalBrokerageAmountRevenue +=
        rate.brokerageAmountRevenue || 0;
      totalCalculatedRates.totalNetFreightRevenue +=
        rate.netFreightRevenue || 0;
      totalCalculatedRates.totalNetFreightExpense +=
        rate.netFreightExpense || 0;
      totalCalculatedRates.totalLaytimeRevenueRevenue +=
        rate.laytimeRevenueRevenue || 0;
      totalCalculatedRates.totalLaytimeRevenueExpense +=
        rate.laytimeRevenueExpense || 0;
      totalCalculatedRates.totalNetRevenue += rate.netRevenue || 0;
      totalCalculatedRates.totalNetExpense += rate.netExpense || 0;
      totalCalculatedRates.totalNetFreight += rate.totalNetFreight || 0;
      totalCalculatedRates.totalLaytimeProfit += rate.totalLaytimeProfit || 0;
      totalCalculatedRates.netProfit += rate.netProfit || 0;
    });
    currentdata.totalCalculatedRates = totalCalculatedRates;
    setCalculatorData(currentdata);
  };

  const sendCalculationRequest = async () => {
    setLoader(true, "Saving calculation details...");
    await updateEstimateCargo({ _id: id }, { ...calculatorData })
      .then((res) => {
        toastSuccess("Details updated successfully");
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const onChangeRevenueOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let customerCargoList = [
      ...(calculatorData.customerCargo?.cargoList || calculatorData?.cargoList),
    ];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value
      );
      customerCargoList[index]["terms"] = value;
      customerCargoList[index]["factor"] =
        (termFactor && termFactor.value) || 0;
    } else {
      customerCargoList[index][name] = value;
    }
    if (calculatorData?.freightModeRevenue === "Single Freight") {
      if (name === "freight") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.freight = value;
          }
        });
      } else if (name === "adcom") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.adcom = value;
          }
        });
      } else if (name === "other") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.other = value;
          }
        });
      } else if (name === "brokerage") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.brokerage = value;
          }
        });
      }
    }
    let updatedCalculatorData = {
      ...calculatorData,
      customerCargo: {
        ...(calculatorData.customerCargo || calculatorData),
        cargoList: customerCargoList,
      },
    };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangeExpenseOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let customerCargoList = [
      ...(calculatorData.vendorCargo?.cargoList || calculatorData?.cargoList),
    ];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value
      );
      customerCargoList[index]["terms"] = value;
      customerCargoList[index]["factor"] =
        (termFactor && termFactor.value) || 0;
    } else {
      customerCargoList[index][name] = value;
    }

    if (calculatorData?.freightModeExpense === "Single Freight") {
      if (name === "freight") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.freight = value;
          }
        });
      } else if (name === "adcom") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.adcom = value;
          }
        });
      } else if (name === "other") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.other = value;
          }
        });
      } else if (name === "brokerage") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.brokerage = value;
          }
        });
      }
    }
    let updatedCalculatorData = {
      ...calculatorData,
      vendorCargo: {
        ...(calculatorData.vendorCargo || calculatorData?.cargoList),
        cargoList: customerCargoList,
      },
    };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangePortOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let vesselVoyageData = [...calculatorData.vesselVoyageData];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value
      );
      vesselVoyageData[index]["terms"] = value;
      vesselVoyageData[index]["factor"] = (termFactor && termFactor.value) || 0;
    } else {
      vesselVoyageData[index][name] = value;
    }
    if (datename === "departureTime" || datename === "arrivalTime") {
      if (
        vesselVoyageData[index]?.departureTime &&
        vesselVoyageData[index]?.arrivalTime
      ) {
        vesselVoyageData[index].portStay = calculateDifference(
          vesselVoyageData[index]?.arrivalTime,
          vesselVoyageData[index]?.departureTime
        );
      }
    }
    let updatedCalculatorData = { ...calculatorData, vesselVoyageData };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangeFields = (e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }

    let calculatorDetailsData = { ...calculatorData };
    if (name === "freightModeRevenue") {
      if (value === "Single Freight") {
        let firstLoadPort = {}; // reset values to first loading port

        const cargoListRevenue =
          calculatorDetailsData?.customerCargo?.cargoList?.map(
            (item, index) => {
              if (
                !Object.keys(firstLoadPort).length &&
                item.operation === "Loading"
              )
                firstLoadPort = {
                  freight: item.freight,
                  adcom: item.adcom,
                  other: item.other,
                  brokerage: item.brokerage,
                };
              if (index !== 0 && item.operation === "Loading") {
                return {
                  ...item,
                  ...firstLoadPort,
                };
              }
              return item;
            }
          );
        calculatorDetailsData.customerCargo.cargoList = cargoListRevenue;
      } else if (value === "Multi Freight") {
      }
    }
    if (name === "freightModeExpense") {
      if (value === "Single Freight") {
        let firstLoadPort = {}; // reset values to first loading port

        const cargoListRevenue =
          calculatorDetailsData?.vendorCargo?.cargoList?.map((item, index) => {
            if (
              !Object.keys(firstLoadPort).length &&
              item.operation === "Loading"
            )
              firstLoadPort = {
                freight: item.freight,
                adcom: item.adcom,
                other: item.other,
                brokerage: item.brokerage,
              };
            if (index !== 0 && item.operation === "Loading") {
              return {
                ...item,
                ...firstLoadPort,
              };
            }
            return item;
          });
        calculatorDetailsData.vendorCargo.cargoList = cargoListRevenue;
      } else if (value === "Multi Freight") {
      }
    }
    calculatorDetailsData[name] = value;
    setCalculatorData(calculatorDetailsData);
    calculate(calculatorDetailsData);
  };

  const onChangeModelFields = (
    e,
    isDate = false,
    datename,
    cargocargo = "customerCargo"
  ) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let calculatorDetailsData = { ...calculatorData?.[cargocargo] };
    calculatorDetailsData[name] = value;
    let calculatorDataDetails = { ...calculatorData };
    calculatorDataDetails[cargocargo] = calculatorDetailsData;
    setCalculatorData(calculatorDataDetails);
  };
  const onClickCopyToMyCargo = () => {
    setCopyConfirm(!isCopyConfirm);
    setShareLabel("");
  };
  const onCopySaveClick = async () => {
    if (!shareLabel || !rawEstimateContract || !organizationId) return;
    setLoader(true, "Copying estimation...");
    const { _id, userId, access, createdAt, contractName, updateAt, ...rest } =
      rawEstimateContract;
    const payload = {
      contractName: shareLabel,
      ...rest,
    };
    await createEstimateContract(payload)
      .then(() => {
        setLoader(false);
        toastSuccess("Estimation copied Successfully");
        setCopyConfirm(false);
        setShareLabel("");
      })
      .catch((err) => {
        setLoader(false);
        toastError("Failed to copy estimation to estimate contract");
      });
  };

  const onClickEditCargoContract = () => {
    setEditCargoContractModelOpen(true);
    const data = rawEstimateContract?.cargoContractDetails;
    setCargoFormData((prev) => ({ ...prev, ...data }));
    setPrevAttachments({
      attachments: [...(data?.attachments || [])],
      textContract: data?.textContract,
    });
  };
  const handleUpdateCargoContract = () => {
    const { _id, actualCargoContract, operationCargoContract, ...payload } = cargoFormData;
    const cpDate = payload.cpDate || payload.contractDate || payload.cp_date || moment().format("YYYY-MM-DD");
    const formPayload = new FormData();

    if (!payload.contractName) {
      toastError("Contract name is required.");
      return;
    }
    if (cargoTextContract) {
      const fileType = cargoTextContract.type || "application/octet-stream";
      const fileName = cargoTextContract.name || "contract";

      const textBlob = new Blob([cargoTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    // Append attachments if available
    if (cargoAttachments?.length) {
      cargoAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    // Append form data
    formPayload.append(
      "data",
      JSON.stringify({
        ...payload,
        cpDate,
        isContract: true,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    setLoader(true, "Updating cargo contract...");
    updateEstimateCargo({ _id: id }, formPayload)
      .then(() => {
        setLoader(false);
        setEditCargoContractModelOpen(false);
        setCargoAttachments([]);
        setCargoTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        getInitialData(id);
        toastSuccess("Cargo Contract Updated successfully!!");
      })
      .catch((err) => {
        setLoader(false);
        toastError(err.message);
      });
  };
  const removeCargoAttachment = (index) => {
    setCargoAttachments((prev) => (Array.isArray(prev) ? prev : []).filter((_, i) => i !== index));
  };
  const handleCargoContractInputChange = (e) => {
    const { name, value } = e.target;
    setCargoFormData({
      ...cargoFormData,
      [name]: value,
    });
  };

  const handleCargoTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  };

  const handleCargoContractAttachmentUpload = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setCargoAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };
  return (
    <Grid className="calculator-section min-h-[calc(100vh-60px)] px-0 md:px-5 py-5">
      <Grid item xs={12}>
        <Grid>
          <Grid item xs={12}>
            <div className="quick-menu-bar items-center grid grid-cols-1 md:grid-cols-6 justify-between p-0 m-0">
              <div className="md:col-span-2 w-fit">
                {contractId && <CustomTabs
                  tabs={tabs}
                  active={active}
                  onChange={handleMainTabChange}
                />}
              </div>
              <div className="md:col-span-4">
                <ActionButtonsCargoCargo
                  onClickCalculateAndSave={sendCalculationRequest}
                  calculatorData={rawEstimateContract}
                  onClickCopyToMyCargo={onClickCopyToMyCargo}
                  isContractEstimate
                  isPrivate={isPrivate}
                />
              </div>
            </div>
            <div className="operation-input-div pb-2 flex items-center">
              <span style={{ marginRight: 8 }}>Performing Vessel : </span>
              {(() => {
                const currentVesselValue = selectedVessel === "cleared" ? null : (selectedVessel || savedVesselValue);

                const hasNewSelection = selectedVessel !== null;
                const hasSavedSelection = savedVesselValue && !hasNewSelection;

                const inputWidth = currentVesselValue?.vesselLabel ? Math.max(170, currentVesselValue.vesselLabel.length * 6.2 + 55) : 170;

                return (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                      options={vesselOptions.length > 0 ? vesselOptions : (currentVesselValue ? [currentVesselValue] : [])}
                      value={currentVesselValue}
                      size="small"
                      style={{ width: inputWidth, transition: 'width 0.2s ease-in-out' }}
                      classes={{ paper: "!w-max !min-w-[170px]" }}
                      ListboxProps={{ className: "scroll-thin max-h-[400px]", style: { minWidth: "max-content", whiteSpace: "nowrap", overflowY: "auto" } }}
                      getOptionLabel={(option) => option.vesselLabel || ""}
                      getOptionSelected={(option, value) => option.vesselLabel === value.vesselLabel}
                      className="autocomplete-mui bg-white"
                      onChange={(e, value) => {
                        setSelectedVessel(value === null ? "cleared" : value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Search vessel…"
                          onChange={(e) => delayVesselSearch(e.target.value)}
                          size="small"
                          inputProps={{
                            ...params.inputProps,
                            style: { ...params.inputProps.style, fontSize: "12px", textOverflow: "ellipsis" }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { ...params.InputProps.style, fontSize: "12px" },
                            endAdornment: (
                              <React.Fragment>
                                {isVesselLoading ? (
                                  <CircularProgress color="inherit" size={15} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {currentVesselValue && currentVesselValue !== "cleared" && (
                      <VisibilityIcon
                        style={{ cursor: 'pointer', fontSize: 24, color: '#313C4C', marginLeft: 10, marginRight: hasNewSelection ? 0 : 8 }}
                        onClick={() => {
                          if (hasSavedSelection) {
                            setPreviewVessel(null);
                            setShowVesselModal(true);
                          } else {
                            const option = currentVesselValue;
                            const vesselConsumptions = mapVesselConsumptions(option.vesselData);
                            const previewInnerVessel = {
                              vesselName: option.vesselName,
                              vesselDwt: option.vesselDwt || option.vesselData?.vesselDwt || option.vesselData?.DWT || option.vesselData?.dwt || 0,
                              vesselIMO: option.vesselData?.IMO || 0,
                              vesselNRT: option.vesselData?.NRT || 0,
                              vesselMMSI: option.vesselData?.MMSI || 0,
                              vesselTPC: option.vesselData?.TPC || 0,
                              vesselGears: option.vesselData?.Gears || 0,
                              vesselGrabs: option.vesselData?.Grabs || 0,
                              vesselFlag: option.vesselData?.Flag || 0,
                              vesselDraftS: option.vesselData?.Draft || 0,
                              vesselClass: option.vesselData?.Class || 0,
                              vesselBuilt: option.vesselData?.built || 0,
                              vesselGrainCap: option.vesselData?.grain || 0,
                              vesselLOA: option.vesselData?.LOA || 0,
                              vesselBeam: option.vesselData?.Beam || 0,
                              vesselGRT: option.vesselData?.GRT || 0,
                              vesselLightShip: option.vesselData?.light_ship || 0,
                              vesselBaleCap: option.vesselData?.bale_capacity || 0,
                              vesselBalComb1Selected: option.vesselData?.BalComb1 || false,
                              vesselBalComb2Selected: option.vesselData?.BalComb2 || false,
                              vesselBalComb3Selected: option.vesselData?.BalComb3 || false,
                              vesselBalComb4Selected: option.vesselData?.BalComb4 || false,
                              vesselLadComb1Selected: option.vesselData?.LadComb1 || false,
                              vesselLadComb2Selected: option.vesselData?.LadComb2 || false,
                              vesselLadComb3Selected: option.vesselData?.LadComb3 || false,
                              vesselLadComb4Selected: option.vesselData?.LadComb4 || false,
                              vesselExtraDetails: {},
                              ...vesselConsumptions,
                            };

                            setPreviewVessel(previewInnerVessel);
                            setShowVesselModal(true);
                          }
                        }}
                      />
                    )}
                    {hasNewSelection && (
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          let performingVesselString = "";
                          if (selectedVessel && selectedVessel !== "cleared") {
                            const vesselConsumptions = mapVesselConsumptions(selectedVessel.vesselData);

                            let existingVessel = {};
                            try {
                              existingVessel = JSON.parse(calculatorData?.performingVessel || "{}");
                            } catch (e) { }

                            const innerVessel = {
                              ...existingVessel,
                              vesselName: selectedVessel.vesselName,
                              vesselDwt: selectedVessel.vesselDwt || selectedVessel.vesselData?.vesselDwt || selectedVessel.vesselData?.DWT || selectedVessel.vesselData?.dwt || 0,
                              vesselIMO: selectedVessel.vesselData?.IMO || 0,
                              vesselNRT: selectedVessel.vesselData?.NRT || 0,
                              vesselMMSI: selectedVessel.vesselData?.MMSI || 0,
                              vesselTPC: selectedVessel.vesselData?.TPC || 0,
                              vesselGears: selectedVessel.vesselData?.Gears || 0,
                              vesselGrabs: selectedVessel.vesselData?.Grabs || 0,
                              vesselFlag: selectedVessel.vesselData?.Flag || 0,
                              vesselDraftS: selectedVessel.vesselData?.Draft || 0,
                              vesselClass: selectedVessel.vesselData?.Class || 0,
                              vesselBuilt: selectedVessel.vesselData?.built || 0,
                              vesselGrainCap: selectedVessel.vesselData?.grain || 0,
                              vesselLOA: selectedVessel.vesselData?.LOA || 0,
                              vesselBeam: selectedVessel.vesselData?.Beam || 0,
                              vesselGRT: selectedVessel.vesselData?.GRT || 0,
                              vesselLightShip: selectedVessel.vesselData?.light_ship || 0,
                              vesselBaleCap: selectedVessel.vesselData?.bale_capacity || 0,
                              port: existingVessel.port,
                              vesselBalComb1Selected: selectedVessel.vesselData?.BalComb1 || false,
                              vesselBalComb2Selected: selectedVessel.vesselData?.BalComb2 || false,
                              vesselBalComb3Selected: selectedVessel.vesselData?.BalComb3 || false,
                              vesselBalComb4Selected: selectedVessel.vesselData?.BalComb4 || false,
                              vesselLadComb1Selected: selectedVessel.vesselData?.LadComb1 || false,
                              vesselLadComb2Selected: selectedVessel.vesselData?.LadComb2 || false,
                              vesselLadComb3Selected: selectedVessel.vesselData?.LadComb3 || false,
                              vesselLadComb4Selected: selectedVessel.vesselData?.LadComb4 || false,
                              vesselExtraDetails: {},
                              ...vesselConsumptions,
                            };
                            performingVesselString = JSON.stringify(innerVessel);
                          }

                          const updatedData = {
                            ...calculatorData,
                            performingVessel: performingVesselString
                          };
                          setCalculatorData(updatedData);
                          calculate(updatedData);
                          setLoader(true, "Updating vessel details...");
                          updateEstimateCargo({ _id: id }, { ...updatedData, organizationId })
                            .then(() => {
                              setLoader(false);
                              toastSuccess("Vessel details updated successfully");
                              setSelectedVessel(null);
                            })
                            .catch((err) => {
                              setLoader(false);
                              toastError(err?.response?.data?.message || err?.message || "Failed to update vessel details");
                            });
                        }}
                        style={{ textTransform: "capitalize", marginLeft: 8 }}
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                );
              })()}
            </div>
          </Grid>
          <div className="middle-section-grid d-flex">
            <Grid container alignItems="flex-end">
              <Grid item xs={10} className="pr-1">
                <CargoCargoPortOperations
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangePortOperations={onChangePortOperations}
                  isContractEstimate
                  onClickEditCargoContract={onClickEditCargoContract}
                />
              </Grid>
              <Grid item xs={2}>
                {calculatorData && (
                  <NetProfitResult
                    label="Net Profit Result"
                    // calculationErrors={calculationErrors}
                    calculatorData={calculatorData}
                  />
                )}
              </Grid>
            </Grid>
          </div>
          <div className="pt-2 pb-2">
            <Grid item xs={12}>
              <div className="pb-1">
                <span style={{ fontSize: "16px", fontWeight: 500 }}>
                  Revenue Side :{" "}
                </span>
              </div>
              <div className="d-flex">
                <div className="operation-input-div cargo-cargo-div pb-1">
                  <span>Freight Mode: </span>
                  <select
                    id="freightModeRevenue"
                    value={calculatorData?.freightModeRevenue}
                    name="freightModeRevenue"
                    onChange={(e) => onChangeFields(e)}
                  >
                    <option key={0} value="Single Freight">
                      Single Freight
                    </option>
                    <option key={1} value="Multiple Freight">
                      Multiple Freight
                    </option>
                  </select>
                </div>
                <div
                  className="operation-input-div cargo-cargo-div pb-1 pl-2 underline"
                  onClick={() => setOpenCargoDetails("customerCargo")}
                >
                  Cargo Details
                </div>
              </div>
            </Grid>
            <div className="middle-section-grid d-flex">
              <Grid item xs={10} className="pr-1">
                <Revenue
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangeRevenueOperations={onChangeRevenueOperations}
                  freightMode={calculatorData?.freightModeRevenue}
                />
              </Grid>
              <Grid item xs={2}>
                {calculatorData && (
                  <CargoCargoResult
                    label="Customer Side (Revenue):"
                    isCustomerSide
                    calculatorData={calculatorData}
                  // calculationErrors={calculationErrors}
                  />
                )}
              </Grid>
            </div>
          </div>
          <div className="pt-2 pb-2">
            <Grid item xs={12}>
              <div className="pb-1">
                <span style={{ fontSize: "16px", fontWeight: 500 }}>
                  Expense Side :{" "}
                </span>
              </div>
              <div className="d-flex">
                <div className="operation-input-div cargo-cargo-div pb-1">
                  <span>Freight Mode: </span>

                  <select
                    value={calculatorData?.freightModeExpense}
                    name="freightModeExpense"
                    onChange={(e) => onChangeFields(e)}
                  >
                    <option key={0} value="Single Freight">
                      Single Freight
                    </option>
                    <option key={0} value="Multiple Freight">
                      Multiple Freight
                    </option>
                  </select>
                </div>
                <div
                  className="operation-input-div cargo-cargo-div pb-1 pl-2 underline"
                  onClick={() => setOpenCargoDetails("vendorCargo")}
                >
                  Cargo Details
                </div>
              </div>
            </Grid>
            <div className="middle-section-grid d-flex">
              <Grid item xs={10} className="pr-1">
                <Expense
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangeExpenseOperations={onChangeExpenseOperations}
                  freightMode={calculatorData?.freightModeExpense}
                />
              </Grid>
              <Grid item xs={2}>
                {calculatorData && (
                  <CargoCargoResult
                    label="Vendor Side (Expense)"
                    calculatorData={calculatorData}
                  />
                )}
              </Grid>
            </div>
          </div>

          <CustomAddModal
            open={openCargoDetails}
            handleClose={() => setOpenCargoDetails(false)}
            maxWidth="lg"
            title={`${openCargoDetails === "customerCargo"
              ? "Revenue side"
              : "Vendor side"
              } cargo details`}
            saveLabel={"Update"}
            onSubmitConfirm={() => setOpenCargoDetails(false)}
          >
            <CargoDetails
              calculatorData={calculatorData}
              onChangeHandler={onChangeFields}
              onChangeModelFields={onChangeModelFields}
              cargoCargo={openCargoDetails}
            />
          </CustomAddModal>

          <CustomAddModal
            open={isCopyConfirm}
            handleClose={onClickCopyToMyCargo}
            onSubmitConfirm={onCopySaveClick}
            maxWidth="xs"
            saveLabel="Create"
            title="Copy To Estimation"
          >
            <ShareWithOrg
              value={shareLabel}
              onChange={(e) => setShareLabel(e.target.value)}
              placeholder="Enter Contract name*"
              label="Estimate name"
              guidanceTitle="Copy this pre-fix estimate"
              guidance="Create a separate copy of this pre-fix estimate. Find it in Contracts → My Contracts → Pre-Fix Estimate."
            />
          </CustomAddModal>
          {isPrivate ? (
            <CustomAddModal
              open={editCargoContractModelOpen}
              title={"Update Cargo Contract"}
              maxWidth="md"
              saveLabel={"Update"}
              handleClose={() => setEditCargoContractModelOpen(false)}
              onSubmitConfirm={handleUpdateCargoContract}
            >
              <CreateCargoContractForm
                formData={cargoFormData}
                setFormData={setCargoFormData}
                handleChange={handleCargoContractInputChange}
                removeAttachment={removeCargoAttachment}
                textContract={cargoTextContract}
                handleTextContractUpload={handleCargoTextContractUpload}
                handleAttachmentUpload={handleCargoContractAttachmentUpload}
                attachments={cargoAttachments}
                setTextContract={setCargoTextContract}
                isEditing
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            </CustomAddModal>
          ) : (
            <CustomShowModal
              open={editCargoContractModelOpen}
              title={"View Cargo Contract"}
              maxWidth="md"
              handleClose={() => setEditCargoContractModelOpen(false)}
            >
              <CreateCargoContractForm
                formData={cargoFormData}
                setFormData={setCargoFormData}
                handleChange={handleCargoContractInputChange}
                removeAttachment={removeCargoAttachment}
                textContract={cargoTextContract}
                handleTextContractUpload={handleCargoTextContractUpload}
                handleAttachmentUpload={handleCargoContractAttachmentUpload}
                attachments={cargoAttachments}
                setTextContract={setCargoTextContract}
                isEditing
                prevAttachments={prevAttachments}
                setPrevAttachments={setPrevAttachments}
              />
            </CustomShowModal>
          )}

          <CustomAddModal
            open={showVesselModal}
            handleClose={() => {
              setShowVesselModal(false);
              setPreviewVessel(null);
            }}
            onSubmitConfirm={() => {
              if (vesselModelRef.current) {
                vesselModelRef.current.submit();
              }
            }}
            maxWidth="lg"
            title="View Vessel Details"
            saveLabel="Save"
          >
            <VesselViewModel
              ref={vesselModelRef}
              currentContract={(() => {
                const vesselStr = previewVessel ? JSON.stringify(previewVessel) : (calculatorData?.performingVessel || "{}");
                let parsed = {};
                try {
                  parsed = JSON.parse(vesselStr);
                } catch (e) { }
                return {
                  ...parsed,
                  vessel: vesselStr,
                };
              })()}
              isFromCreateVessel={!previewVessel}
              isOps={false}
              isViewOnly={false}
              setLoader={setLoader}
              onSaveOverride={(updatedVal) => {
                let parsedSelectedVessel = {};
                try {
                  parsedSelectedVessel = JSON.parse(updatedVal.vessel || "{}");
                } catch (e) { }

                const { vessel: _v, ...restContractFields } = updatedVal;

                const fullPerformingVesselObj = {
                  ...parsedSelectedVessel,
                  ...restContractFields,
                };

                const performingVesselString = JSON.stringify(fullPerformingVesselObj);

                const draftData = {
                  ...calculatorData,
                  performingVessel: performingVesselString
                };
                setCalculatorData(draftData);
                calculate(draftData);
                setLoader(true, "Saving vessel details...");
                updateEstimateCargo({ _id: id }, { ...draftData, organizationId })
                  .then(() => {
                    setLoader(false);
                    toastSuccess("Vessel details updated successfully");
                    setShowVesselModal(false);
                    setPreviewVessel(null);
                    setSelectedVessel(null);
                  })
                  .catch((err) => {
                    setLoader(false);
                    toastError(err?.response?.data?.message || err?.message || "Failed to update vessel details");
                  });
              }}
            />
          </CustomAddModal>
        </Grid>
      </Grid>
    </Grid>
  );
}
